import Cookies from 'js-cookie'

const RememberKey = 'remember';

export function getRemember() {
	if (window.localStorage)
		return localStorage.getItem(RememberKey) || false;
	else
		return Cookies.get(RememberKey) || false;
}

export function setRemember(Account) {
  	if (window.localStorage)
		localStorage.setItem(RememberKey, Account);

	return Cookies.set(RememberKey, Account);
}

export function removeRemember() {
	if (window.localStorage)
		localStorage.removeItem(RememberKey);

 	return Cookies.remove(RememberKey);
}